
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import "../css/loader.css";
import "../css/main.css";
export function useAPICall(
) {
  const navigate = useNavigate();
  let dataLoaded = useRef(false);
  
  // we don't useEffect here, we are only interested in function logoutUser

  const ShowSpinner = (() => {
    return (

   <div className='spinnerholder' id='loadingdiv'>
        <div className='loader'>

        </div>
   </div>

    )
  });
  function handleShowError(message) {
    document.getElementById('errorbox').style.display = 'block';
    document.getElementById('errorboxmessage').textContent = message;
    
  }

  function handleHideError() {
    document.getElementById('errorbox').style.display = 'none';

  }

  const ShowError = (() => {
    return (
      <div className='errorbox' id='errorbox'>
        <div id='errorboxmessage' className='errorboxmessage'></div>
        <div className='errorboxmessage' onClick={handleHideError}><button className='prcbtn'>OK</button></div>
      </div>);
  });

  const MakeCall = ((targetRoute, postBody, completeCallback, forceCall) => {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(postBody)
    };
    if (!dataLoaded.current || forceCall) {
      let loadingEl = document.getElementById("loadingdiv");
      if (loadingEl) {
        loadingEl.style.display = "block";
      }

      fetch('https://prcmembership.com:7264/api/' + targetRoute, requestOptions).then(res => res.json())      
      //fetch('https://localhost:44339/api/' + targetRoute, requestOptions).then(res => res.json())      
        .then(data => {
          let loadingEl = document.getElementById("loadingdiv");
          if (loadingEl) {
            loadingEl.style.display = "none";
          }
          dataLoaded.current = true;

          if (data.components['result']) {
            if (data.components['result'].succeeded === false) {
              handleShowError("Error : " + data.components['result'].message);
            }
          }
          if (data.result.succeeded === true) {
            
            console.log('call ' + targetRoute);
            sessionStorage.setItem("Token", data.components['token'].token);
            sessionStorage.setItem("Expiry", new Date(data.components['token'].expiry) * 1);
            sessionStorage.setItem("permission_names", data.components['token'].permission_names);
            if (completeCallback) {
              completeCallback(data);
            }
          }
          else {
            let loadingEl = document.getElementById("loadingdiv");
            if (loadingEl) {
              loadingEl.style.display = "none";
            }

            if (data.result.forwardurl.length > 0) {
              navigate(data.result.forwardurl);
            }
          }

        })
        .catch(rejected => {
          let loadingEl = document.getElementById("loadingdiv");
          if (loadingEl) {
            loadingEl.style.display = "none";
          }
          console.log(rejected);
          navigate("/Login");
        });
    }
  });
  return { MakeCall, ShowSpinner, ShowError };


}



